import * as React from "react";

interface Props extends React.SVGProps<SVGSVGElement> {
    size?: number;
}

const DeleteIcon = ({ size = 15, ...props }: Props) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3 1.2C3 0.88174 3.12643 0.576515 3.35147 0.351472C3.57652 0.126428 3.88174 0 4.2 0H7.8C8.11826 0 8.42348 0.126428 8.64853 0.351472C8.87357 0.576515 9 0.88174 9 1.2V2.4H11.4C11.5591 2.4 11.7117 2.46321 11.8243 2.57574C11.9368 2.68826 12 2.84087 12 3C12 3.15913 11.9368 3.31174 11.8243 3.42426C11.7117 3.53679 11.5591 3.6 11.4 3.6H10.7586L10.2384 10.8852C10.2169 11.188 10.0814 11.4713 9.85927 11.6781C9.63716 11.885 9.34492 12 9.0414 12H2.958C2.65448 12 2.36224 11.885 2.14013 11.6781C1.91802 11.4713 1.78255 11.188 1.761 10.8852L1.242 3.6H0.6C0.44087 3.6 0.288258 3.53679 0.175736 3.42426C0.0632141 3.31174 0 3.15913 0 3C0 2.84087 0.0632141 2.68826 0.175736 2.57574C0.288258 2.46321 0.44087 2.4 0.6 2.4H3V1.2ZM4.2 2.4H7.8V1.2H4.2V2.4ZM2.4444 3.6L2.9586 10.8H9.042L9.5562 3.6H2.4444ZM4.8 4.8C4.95913 4.8 5.11174 4.86321 5.22426 4.97574C5.33679 5.08826 5.4 5.24087 5.4 5.4V9C5.4 9.15913 5.33679 9.31174 5.22426 9.42426C5.11174 9.53679 4.95913 9.6 4.8 9.6C4.64087 9.6 4.48826 9.53679 4.37574 9.42426C4.26321 9.31174 4.2 9.15913 4.2 9V5.4C4.2 5.24087 4.26321 5.08826 4.37574 4.97574C4.48826 4.86321 4.64087 4.8 4.8 4.8ZM7.2 4.8C7.35913 4.8 7.51174 4.86321 7.62426 4.97574C7.73679 5.08826 7.8 5.24087 7.8 5.4V9C7.8 9.15913 7.73679 9.31174 7.62426 9.42426C7.51174 9.53679 7.35913 9.6 7.2 9.6C7.04087 9.6 6.88826 9.53679 6.77574 9.42426C6.66321 9.31174 6.6 9.15913 6.6 9V5.4C6.6 5.24087 6.66321 5.08826 6.77574 4.97574C6.88826 4.86321 7.04087 4.8 7.2 4.8Z"
            fill={props.color || "currentColor"}
        />
    </svg>
);
export default DeleteIcon;
